export default "__VITE_ASSET__OJURd0tA__"